export const formatPhoneGT = (value?: string): string => {
  if (!value) return ''

  let digits = value.replace(/[^\d+]/g, '')
  let country = ''

  if (digits.startsWith('+502')) {
    country = '+502 '
    digits = digits.replace('+502', '')
  } else if (digits.startsWith('502')) {
    country = '+502 '
    digits = digits.substring(3)
  }

  digits = digits.replace(/\D/g, '').slice(0, 8)

  if (digits.length <= 4) return country + digits

  return country + digits.slice(0, 4) + '-' + digits.slice(4)
}
